import { Component, Input } from '@angular/core';

@Component({
  selector: 'sag-ui-radio-group',
  template: `
    <div class="flex flex-col gap-2">
      <label sag-ui-radio-group-label
        >{{ label
        }}<sup *ngIf="required" class="text-[#D72339] dark:text-[#FF2640]"
          >*</sup
        ></label
      >
      <div
        class="flex"
        [class.flex-col]="direction === 'column'"
        [style]="{ gap: gap + 'px' }"
      >
        <ng-content></ng-content>
      </div>
    </div>
  `,
})
export class RadioGroupComponent {
  @Input() required = false;
  @Input() label: string;
  @Input() direction: 'row' | 'column' = 'column';
  @Input() gap = 10;
}
